// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","524":"app","933":"auth"}[chunkId] || chunkId) + "." + {"85":"b32d9185","119":"b01de115","458":"4f4a451a","523":"1ffe7e97","524":"ef8ca52b","933":"814c8ec7"}[chunkId] + ".chunk.js";
};